import React, { useState } from "react";
import "../styles/NeedHelpRecommendationStyle.css";
import CloseButton from "../../assets/images/needHelp/closeBtn.png";
import HelpIcon from "../../assets/images/needHelp/needHellpWhite.png";
import card2Img from "../../assets/images/needHelp/queryImg.png";
import card3Img1 from "../../assets/images/needHelp/videoImg.png";
import card3Img2 from "../../assets/images/needHelp/docImg.png";
import { useLocation } from "react-router-dom";
import needhelpprogramSchedule from "../../../../assets/images/calender/needhelpschedule.png";
interface RightModalProps {
  isOpen: boolean;
  toggleModal: () => void;
}

interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

const faqData: FAQItem[] = [
  {
    question: "What is the Recommendation Module?",
    answer: (
      <div>
        <p>
          The Recommendation Module provides personalized learning content for
          career and skill development.
        </p>

        <p>
          Sections like <b>Building Blocks</b>, <b>Strengthening Steps</b>, and
          <b> Performance Moments</b> represent different courses and learning
          stages. Categories such as <b>Life & Career Skills</b>,{" "}
          <b>Learning & Innovation Skills</b>,{" "}
          <b>ICT Skills, and Interdisciplinary Skills</b> represent skill
          dimensions, while areas like{" "}
          <b> & Responsibility and Productivity & Accountability</b>Leadership
          represent specific skills explored through curated videos and learning
          resources.
        </p>
      </div>
    ),
  },

  {
    question: "How does the Discussion Board work with learning content?",
    answer: (
      <div className="recommendation-answer-layout">
        <div className="recommendation-answer-left">
          <p>
            Users can ask questions directly to tutors through the Discussion
            Board.
          </p>

          <p>
            When users click on a video, the related discussion section opens
            allowing learners to interact and participate in discussions.
          </p>
        </div>

        <div className="recommendation-answer-right">
          <img src={card2Img} alt="discussion-board" />
        </div>
      </div>
    ),
  },
  {
    question: "What is included in the Learning Content section?",
    answer: (
      <div className="recommendation-answer-layout">
        {/* Left Content */}
        <div className="recommendation-answer-left">
          <p>
            The Learning Content section includes video lessons and learning
            materials provided in the form of PDFs.
          </p>

          <p>
            These resources are designed to support step-by-step learning and
            help users understand each topic more effectively.
          </p>
        </div>

        {/* Right Side Cards */}
        <div className="recommendation-learning-cards">
          <div className="recommendation-learning-card">
            <img src={card3Img1} alt="video" />

            <span>Video Title</span>
          </div>

          <div className="recommendation-learning-card">
            <img src={card3Img2} alt="document" />

            <span>Document Title</span>
          </div>
        </div>
      </div>
    ),
  },
];
const faqDataAssessment: FAQItem[] = [
  {
    question: "How do I take an assessment?",
    answer: (
      <div>
        <p>
          Assessments you are eligible to take will appear in a list when you
          click on the “Assessments” menu. In case none have been configured for
          you, you will see a message informing you of this.
        </p>
      </div>
    ),
  },
  {
    question: "Do I need a One-Time-Password(OTP) to start the assessment?",
    answer: (
      <div>
        <p>
          Yes. All assessments are secured and you will need to enter an OTP to
          begin the assessment. Reach out to your Institute administrator for
          the OTP. In case you are an independent learner, generate your own OTP
          to begin the assessment.{" "}
        </p>
      </div>
    ),
  },
  {
    question: "Are assessments proctored?",
    answer: (
      <div>
        <p>
          Yes. Assessments are proctored to analyze body language and detect
          malpractice. You will see a detailed report of the proctoring analysis
          along with your interview feedback.{" "}
        </p>
      </div>
    ),
  },
  {
    question: "Do I get notified of an assessment?",
    answer: (
      <div>
        <p>
          Yes. You will receive notifications via email and on your Jozuna
          mobile application when assessments are configured. You will also see
          the scheduled assessments appear in your Learning schedule
          calendar.{" "}
        </p>
      </div>
    ),
  },
];

const programSchedule: FAQItem[] = [
  {
    question: "How does the Learning Schedule work?",
    answer: (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          Different colors are used to represent different event types for easy
          identification
        </p>
        <img src={needhelpprogramSchedule} alt="" style={{ width: "100%" }} />
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          Event names are also highlighted with their respective colors for
          better visibility. Once an event is completed, users receive a
          notification update. When users click on a particular date, all
          scheduled events for that day appear in detail. By selecting the
          “View” option, users can access complete program information,
          including timings, session details, and activity status.
        </p>
      </div>
    ),
  },
];
const interviewIQ: FAQItem[] = [
  {
    question: "What is “Resume Grading”?",
    answer: (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          Resume grading analyses your resume to give detailed and actionable
          feedback on areas of improvement. You get pointers on what lines from
          your resume can be improved or rewritten.
        </p>
      </div>
    ),
  },
  {
    question: "What can I try in “Interview”?",
    answer: (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          Try out 4 rounds of interviews - Technical, HR, Behavioral and Hiring
          Manager rounds, based exclusively on your resume. Our AI system
          analyzes the answers and works on follow up questions.
        </p>
      </div>
    ),
  },
  {
    question: "What is “Match & Optimize”?",
    answer: (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          “Match & Optimize” analyzes how much your resume aligns with a Job
          Description (JD) and provides a detailed report of points that can be
          added to improve the match.
        </p>
      </div>
    ),
  },

  {
    question: "Are interviews proctored?",
    answer: (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          Yes. Interviews are proctored to analyze body language and detect
          malpractice. You will see a detailed report of the proctoring analysis
          along with your interview feedback.
        </p>
      </div>
    ),
  },
  {
    question: "Can the system help me build my resume?",
    answer: (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{ fontFamily: "Mazzard", fontWeight: "400", color: "#2D2D2D" }}
        >
          Under “Match & Optimize” you can describe the scenario you want added
          to the resume, and our AI resume builder frames it professionally to
          be included in your resume. You can accept, reject or have it
          rephrased.
        </p>
      </div>
    ),
  },
];
const RightModalRecommendation: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const location = useLocation();

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  if (!isOpen) {
    return null;
  }

  return (
    <div className="recommendation-needhelp-right-modal open">
      {/* Header */}
      <div className="recommendation-needhelp-top-header">
        <div className="recommendation-needhelp-title-section">
          <img className="recommendation-help-icon" src={HelpIcon} alt="Help" />
          <span
            style={{
              fontWeight: "500",
              fontFamily: "Mazzard",
              color: "#2d2d2d",
            }}
          >
            Need help?
          </span>
        </div>

        <div className="recommendation-needhelp-actions">
          <button
            className="recommendation-support-btn"
            onClick={() =>
              (window.location.href =
                "mailto:support@jozuna.com?subject=Need Help Support")
            }
          >
            <i
              className="fa fa-envelope"
              style={{ marginRight: "8px", fontFamily: "Mazzard" }}
            />
            Get Support
          </button>

          <img
            src={CloseButton}
            alt="close"
            className="recommendation-close-btn"
            onClick={toggleModal}
          />
        </div>
      </div>

      {/* FAQ Section */}
      <div className="recommendation-faq-wrapper">
        {(location.pathname === "/dashboard/recommendation/jozunaview"
          ? faqData
          : location.pathname === "/dashboard/programSchedule"
            ? programSchedule
            : location.pathname === "/dashboard/interview-hub"
              ? interviewIQ
              : faqDataAssessment
        ).map((faq, index) => (
          <div
            className={`recommendation-faq-card ${
              openIndex === index ? "active" : ""
            }`}
            key={index}
          >
            {/* Header */}
            <div
              className="recommendation-faq-header"
              onClick={() => toggleAccordion(index)}
            >
              <h4 style={{ fontFamily: "Mazzard" }}>{faq.question}</h4>

              <span className="recommendation-faq-icon">
                {openIndex === index ? "−" : "+"}
              </span>
            </div>

            {/* Answer */}
            {openIndex === index && (
              <div className="recommendation-faq-body">
                <p style={{ fontFamily: "Mazzard" }}>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RightModalRecommendation;
